"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The InboundCommunication model module.
 * @module model/InboundCommunication
 * @version 3.0
 */
var InboundCommunication = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>InboundCommunication</code>.
   * @alias module:model/InboundCommunication
   */
  function InboundCommunication() {
    _classCallCheck(this, InboundCommunication);
    InboundCommunication.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(InboundCommunication, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>InboundCommunication</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InboundCommunication} obj Optional instance to populate.
     * @return {module:model/InboundCommunication} The populated <code>InboundCommunication</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new InboundCommunication();
        if (data.hasOwnProperty('inboundCommsId')) {
          obj['inboundCommsId'] = _ApiClient["default"].convertToType(data['inboundCommsId'], 'Number');
        }
        if (data.hasOwnProperty('inboundCommsLegacyId')) {
          obj['inboundCommsLegacyId'] = _ApiClient["default"].convertToType(data['inboundCommsLegacyId'], 'String');
        }
        if (data.hasOwnProperty('inboundCommsRefId')) {
          obj['inboundCommsRefId'] = _ApiClient["default"].convertToType(data['inboundCommsRefId'], 'String');
        }
        if (data.hasOwnProperty('userId')) {
          obj['userId'] = _ApiClient["default"].convertToType(data['userId'], 'Number');
        }
        if (data.hasOwnProperty('customerId')) {
          obj['customerId'] = _ApiClient["default"].convertToType(data['customerId'], 'Number');
        }
        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'String');
        }
        if (data.hasOwnProperty('createdDateTime')) {
          obj['createdDateTime'] = _ApiClient["default"].convertToType(data['createdDateTime'], 'Date');
        }
        if (data.hasOwnProperty('modifiedDateTime')) {
          obj['modifiedDateTime'] = _ApiClient["default"].convertToType(data['modifiedDateTime'], 'Date');
        }
        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient["default"].convertToType(data['category'], 'String');
        }
        if (data.hasOwnProperty('detail')) {
          obj['detail'] = _ApiClient["default"].convertToType(data['detail'], 'String');
        }
        if (data.hasOwnProperty('linkedToContent')) {
          obj['linkedToContent'] = _ApiClient["default"].convertToType(data['linkedToContent'], 'Boolean');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InboundCommunication</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InboundCommunication</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['inboundCommsLegacyId'] && !(typeof data['inboundCommsLegacyId'] === 'string' || data['inboundCommsLegacyId'] instanceof String)) {
        throw new Error("Expected the field `inboundCommsLegacyId` to be a primitive type in the JSON string but got " + data['inboundCommsLegacyId']);
      }
      // ensure the json data is a string
      if (data['inboundCommsRefId'] && !(typeof data['inboundCommsRefId'] === 'string' || data['inboundCommsRefId'] instanceof String)) {
        throw new Error("Expected the field `inboundCommsRefId` to be a primitive type in the JSON string but got " + data['inboundCommsRefId']);
      }
      // ensure the json data is a string
      if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
        throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
      }
      // ensure the json data is a string
      if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
        throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
      }
      // ensure the json data is a string
      if (data['detail'] && !(typeof data['detail'] === 'string' || data['detail'] instanceof String)) {
        throw new Error("Expected the field `detail` to be a primitive type in the JSON string but got " + data['detail']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} inboundCommsId
 */
InboundCommunication.prototype['inboundCommsId'] = undefined;

/**
 * @member {String} inboundCommsLegacyId
 */
InboundCommunication.prototype['inboundCommsLegacyId'] = undefined;

/**
 * @member {String} inboundCommsRefId
 */
InboundCommunication.prototype['inboundCommsRefId'] = undefined;

/**
 * @member {Number} userId
 */
InboundCommunication.prototype['userId'] = undefined;

/**
 * @member {Number} customerId
 */
InboundCommunication.prototype['customerId'] = undefined;

/**
 * @member {String} status
 */
InboundCommunication.prototype['status'] = undefined;

/**
 * @member {Date} createdDateTime
 */
InboundCommunication.prototype['createdDateTime'] = undefined;

/**
 * @member {Date} modifiedDateTime
 */
InboundCommunication.prototype['modifiedDateTime'] = undefined;

/**
 * @member {String} category
 */
InboundCommunication.prototype['category'] = undefined;

/**
 * @member {String} detail
 */
InboundCommunication.prototype['detail'] = undefined;

/**
 * @member {Boolean} linkedToContent
 */
InboundCommunication.prototype['linkedToContent'] = undefined;
var _default = exports["default"] = InboundCommunication;